import PropTypes from 'prop-types';
import { googleReverseGeocode } from '@rsos/components/capstone/common/Map/utils';

/**
 * Reverse geocode coordinates using the Google reverse geocode service. The service returns an
 * address and addressObject if it is found, or an error then fallback if it cannot find a result.
 * @param {Number} latitude - The location's latitude
 * @param {Number} longitude - The location's longitude
 * @param {Function} onReverseGeocoding - Sets if the location is being reverse geocoded
 */
const googleReverseGeocodeLocation = ({
  latitude,
  longitude,
  onReverseGeocoding,
}) => {
  const latlng = {
    lat: latitude,
    lng: longitude,
  };

  if (onReverseGeocoding) onReverseGeocoding(true);

  return googleReverseGeocode(latlng)
    .then(response => {
      const address = response?.[0]?.formatted_address
        ? response[0].formatted_address
        : '';

      const addressObject = response?.[0]?.address_components
        ? response[0].address_components
        : null;

      return { address, addressObject };
    })
    .finally(() => {
      if (onReverseGeocoding) onReverseGeocoding(false);
    });
};

googleReverseGeocodeLocation.PropTypes = {
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
  onReverseGeocoding: PropTypes.func,
};

export default googleReverseGeocodeLocation;
